import React, { useContext } from 'react';
import styled from 'styled-components';
import { AppContext } from '@com/core/common/contexts/appContext';

type TProps = {
    data: {
        titleText?: string;
        titleImageUrl?: string;
        linkText?: string;
        linkUrl?: string;
        linkBgColor?: string;
        titleColor?: string;
    };
    textColor?: string;
};

const ModuleHeader = ({ data, textColor }: TProps): JSX.Element => {
    const { locale } = useContext(AppContext);
    return (
        <div className="siteWidthContainer">
            <ModuleHeaderContainer>
                {data.titleText && <Title style={{ color: data.titleColor }}>{data.titleText}</Title>}
                {data.titleImageUrl && (
                    <ImageContainer>
                        <img src={data.titleImageUrl} alt="moduleHeader" />
                    </ImageContainer>
                )}
                {data.linkText && (
                    <Link
                        textColor={textColor}
                        linkBgColor={data.linkBgColor}
                        href={`/${locale.seoLocale}${data.linkUrl}`}>
                        {data.linkText}
                    </Link>
                )}
            </ModuleHeaderContainer>
        </div>
    );
};

const ModuleHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

const Title = styled.h3`
    font-weight: bold;
    font-size: 1.5rem;
    flex: 1;
`;

type TLinkProps = {
    textColor?: string;
    linkBgColor?: string;
};
const Link = styled.a<TLinkProps>`
    color: ${({ textColor, theme }): string => textColor || theme.colors.brandPrimary};
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    border: 1px solid;
    background-color: ${({ linkBgColor, theme }): string => linkBgColor || theme.colors.bgPrimary};
    padding: 8px 16px;
    transition: opacity ease-in-out 0.2s;
    border-radius: ${({ theme }): string => theme.metrics.borderRadius};

    &:hover {
        opacity: 0.7;
    }
`;

const ImageContainer = styled.div`
    img {
        max-height: 48px;
    }
`;

export default ModuleHeader;
